<template>
  <div class="app-container">
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" @click="handleAdd">添加套餐</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="套餐ID" min-width="40" align="center" prop="packageId" />
      <el-table-column label="套餐名称" min-width="100" align="center" prop="packageName"></el-table-column>
      <el-table-column label="包含模块" min-width="200" align="center" prop="containModules" />
      <el-table-column label="有效期" min-width="80" align="center" prop="validity">
        <template slot-scope="scope">{{scope.row.validity}}个月</template>
      </el-table-column>
      <el-table-column label="账号数" min-width="80" align="center" prop="accountNumStr" />
      <el-table-column label="价格（元）" min-width="100" align="center" prop="price">
        <template slot-scope="scope">
          {{scope.row.price == '0' ? '免费' : amountFormat(scope.row.price)}}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="60" align="center" prop="statusStr" />
      <el-table-column label="操作" min-width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
          <!-- <el-button type="text" @click="handleOffline(scope.row)" v-if="scope.row.status === 1">下线</el-button> -->
          <el-button type="text" @click="handleOnline(scope.row)" v-if="scope.row.status === 0">启用</el-button>
          <el-button type="text" @click="handleDelete(scope.row)" v-if="scope.row.status === 0">删除</el-button>
          <el-button type="text" @click="handleEdit(scope.row)" v-if="scope.row.status === 0">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="queryList"
    />
    <!-- <PackageEditDialog ref="addPackageDialogRef" @success="getList"></PackageEditDialog> -->
  </div>
</template>

<script>
import { queryListPackage, changeStatus, packageDel } from "@/api/saas/package";

import { amountFormat } from "@/utils/index";
import PackageEditDialog from "./addPackage";

export default {
  name: "BusinessList",
  data() {
    return {
      total: 1,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      dataList: [
        {
          name: "一体化设备",
          url:
            "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
          type: 2,
          typeDesc: "图文",
          status: 1,
          statusDesc: "已上线",
          updateTime: "2021.03.01 12:12:12"
        }
      ],
      amountFormat
    };
  },
  created() {
    this.queryList();
  },
  components: {
    PackageEditDialog
  },
  methods: {
    handleAdd() {
      this.$router.push("/saas/package/add");
    },
    handleEdit(row) {
      this.$router.push({
        path: "/saas/package/add",
        query: {
          packageId: row.packageId
        }
      });
    },
    // 查看套餐状态
    handleSee(row) {
      this.$router.push({
        path: "/saas/package/detail",
        query: {
          packageId: row.packageId
        }
      });
    },
    // 删除套餐
    handleDelete(row) {
      this.$confirm('确认删除该套餐吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete(row)
      })

    },
    delete(row) {
      packageDel({
        packageId: row.packageId
      })
        .then(response => {
          this.queryList();
          this.$message({
            message: "删除成功",
            type: "success"
          });
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 变更套餐状态 只可启用不让停用
    handleOnline(row) {
      this.$confirm('确定启用该套餐?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeStatus({
          packageId: row.packageId,
          status: 1
        })
          .then(response => {
            this.queryList();
            this.$message({
              message: "启用成功",
              type: "success"
            });
          })
          .catch(error => {
            this.loading = false;
          });
      })
    },
    queryList() {
      this.loading = true;
      queryListPackage(this.queryParams)
        .then(response => {
          this.dataList = response.rows || [];
          this.total = response.total
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.id);
    }
  }
};
</script>
